import Vue from 'vue'
import Router from 'vue-router'
import { Toast } from 'vant';
import { getAuthPath } from '@/utils/auth'

import pay from '@/router/pay'
import app from '@/router/app'
import park from '@/router/park'
import mine from '@/router/mine'
import web from '@/router/web'

Vue.use(Router)

const router = new Router({
  routes: [
    ...pay,
    ...app,
    ...park,
    ...mine,
    ...web,
    /** 微信授权中间页 */
    {
      path: '/wxAuth',
      name: 'WxAuth',
      component: () => import('@/view/WxAuth')
    },
    {
      path: '/wxAuthBase',
      name: 'WxAuthBase',
      component: () => import('@/view/WxAuthBase')
    },
    /** 授权错误页 */
    {
      path: '/authError',
      name: 'AuthError',
      component: () => import('@/view/AuthError')
    },
    {
      path: '/alipayAuth',
      name: 'AlipayAuth',
      component: () => import('@/view/AlipayAuth')
    },
    {
      path: '/devAuth',
      name: 'DevAuth',
      component: () => import('@/view/DevAuth')
    },
  ]
})
router.beforeEach((to, from, next) => {
  const authPath = getAuthPath(to.path)

  // 支付宝环境
  if (authPath === null) {
    if (/alipay/i.test(navigator.userAgent)) {
      window.localStorage.setItem('PayType', "AliPay");
      next()
    } else {
      Toast("请使用微信/支付宝浏览器打开页面")
      return
    }
    return
  }

  // 微信环境
  window.localStorage.setItem('PayType', "WeChatPay");
  let openid = window.localStorage.getItem("openId");

  if (!openid) {
    if (to.path === authPath) {
      next()
    } else {
      window.localStorage.setItem('WXAuthorizeUrl', to.fullPath); // 路由
      next(authPath)
    }
  } else {
    let token = localStorage.getItem('carparkXtoken')
    if(!token){
      if (to.path === authPath) {
        next()
      } else {
        window.localStorage.setItem('WXAuthorizeUrl', to.fullPath); // 路由
        next(authPath)
      }
    } else {
      if(to.path.includes("/app/") && to.path !== '/app/login'){
        // app 验证
        let appUser = window.localStorage.getItem("appUser");
        if(!appUser){
          next('/app/login')
        } else {
          // 正常放行
          next()
        }
      } else {
        // 正常放行
        next()
      }
    }
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js